(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('AbnormalAlert', AbnormalAlert);

    AbnormalAlert.$inject = ['$resource'];

    function AbnormalAlert ($resource) {
        var resourceUrl =  'api/abnormal-alerts/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'saveAll': {url: 'api/abnormal-alerts/save-all', method: 'POST', isArray: true},
            'filter': {url: 'api/abnormal-alerts/filter', method: 'GET', isArray: true},
        });
    }
})();
